import { render, staticRenderFns } from "./bjyLivePlayBack.vue?vue&type=template&id=4eddfa8a&scoped=true"
import script from "./bjyLivePlayBack.vue?vue&type=script&lang=js"
export * from "./bjyLivePlayBack.vue?vue&type=script&lang=js"
import style0 from "./bjyLivePlayBack.vue?vue&type=style&index=0&id=4eddfa8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eddfa8a",
  null
  
)

export default component.exports